export { GRID_CLASSES, ResultList, SKELETON_COUNT } from './ResultList';
export type { ResultListProps } from './ResultList.types';
